import { store } from "../../store";

export const REMOTE_URL = "";
export const GET_DEPT_URL = "/api/v1/departments";
export const ADD_DEPT_URL = "/api/v1/departments/create";
export const UPD_DEPT_URL = "/api/v1/departments/update";
